import {
  css
} from 'lit';

export const NumericSliderStyle = css`
.lds-numeric-slider-container {
  width: 100%;
  display: flex;
  align-items: center;
}

.lds-range-slider {
  display: flex;
  max-width: 100%;
  position: relative;
  flex: 1;
}

/* slider track */
.lds-range-slider .lds-slider {
  display: block;
  height: var(--lds-spacing-range-slider-height);
  width: 100%;
  position: relative;
  z-index: 1;
  background-color: var(--lds-color-range-slider-bg);
}

/* slider thumb */
.lds-slider-thumb {
  display: block;
  position: absolute;
  width: 1.5rem;
  height: 1.5rem;
  cursor: grab;
  background-color: var(--lds-color-range-slider-thumb-bg);
  border-radius: 1000px;
  top: -22px;
  transform: translateY(50%);
  z-index: 2;
}
.lds-slider-thumb::before {
  box-sizing: border-box;
  content: "";
  display: block;
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 1000px;
  box-shadow: 0 3px 8px rgba(33,33,33,.2);
  transition: .25s ease box-shadow;
  cursor: grab;
}
.lds-slider-thumb:hover::before {
  box-shadow: 0 3px 8px rgba(33,33,33,.2),0 0 0 .5rem rgba(0,116,158,.1);
}

.lds-slider-thumb.focused::before {
  outline-color: var(--lds-color-focus-outline);
  outline-offset: var(--lds-border-focus-outline-offset);
  outline-style: var(--lds-border-focus-outline-style);
  outline-width: var(--lds-border-focus-outline-width);
  box-shadow: var(--lds-shadow-focus-3px) var(--lds-color-focus-shadow);
}

/* range input */
.lds-range-slider input[type="range"] {
  -webkit-appearance: none;
  height: var(--lds-spacing-range-slider-height);
  opacity: 0;
  position: absolute;
  width: 100%;
  z-index: 5;
  margin: 0;
  opacity: 0; /* change to 1 for debbuging to see actual range slider in red */
  cursor: pointer;
  background-color: red;
}
.lds-range-slider input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  display: block;
  height: var(--lds-spacing-range-slider-thumb-size);
  width: var(--lds-spacing-range-slider-thumb-size);
  border-radius: 1000px;
  cursor: grab;
}
.lds-range-slider input[type="range"]::-moz-range-thumb {
  appearance: none;
  display: block;
  height: var(--lds-spacing-range-slider-thumb-size);
  width: var(--lds-spacing-range-slider-thumb-size);
  border-radius: 1000px;
  outline: 0;
  border: 0;
  cursor: grab;
}

/* value display */
.value-display {
  position: absolute;
  top: -2.5rem;
  left: 50%;
  width: auto;
  height: 1.5rem;
  padding: 0 .5rem;
  color: var(--lds-color-range-slider-value-foreground);
  background-color: var(--lds-color-range-slider-value-bg);
  border-radius: var(--lds-radius-range-slider-value);
  transform: translateX(-50%);
}

.value-display.fade-enter-active,
.value-display.fade-leave-active {
  transition: all .35s ease;
}

.value-display.fade-enter,
.value-display.fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(10%);
}

.value-display.temporary,
.value-display.never {
  display: none;
}

.moving .value-display.temporary {
  display: block;
}

/* min max labels */
.min-label,
.max-label {
  display: none;
}

.show-min-max .max-label,
.show-min-max .min-label {
  display: inline;
}

.min-label {
  padding-left: var(--lds-spacing-range-slider-min-padding-left);
  padding-right: var(--lds-spacing-range-slider-min-padding-right);
}
.max-label {
  padding-left: var(--lds-spacing-range-slider-max-padding-left);
  padding-right: var(--lds-spacing-range-slider-max-padding-right);
}


/* step indicators */
.steps {
  display: flex;
  position: relative;
  height: var(--lds-spacing-range-slider-height);
}

.step {
  display: none;
  height: var(--lds-spacing-range-slider-height);
  width: var(--lds-spacing-range-slider-height);
  position: absolute;
  background-color: var(--lds-color-range-slider-step);
}

.steps.show .step {
  display: flex;
}

.step.active {
  background-color: var(--lds-color-range-slider-step-active);
}

.step-bar {
  position: absolute;
  height: var(--lds-spacing-range-slider-height);
  left: 0;
  background-color: var(--lds-color-range-slider-thumb-bg);
}



`;

export default NumericSliderStyle;
